import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import shared from "@/store/shared";
import auth from "@/store/auth";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins:[
      createPersistedState({
        storage: window.sessionStorage,
    })
  ],
  state: {
    sidebar_status: true,
    sidebar_status_mini: true,
    sidebar_pinned: false,
  },
  getters: {
    sidebar_status: state => state.sidebar_status,
    sidebar_status_mini: state => state.sidebar_status_mini,
    sidebar_pinned: state => state.sidebar_pinned,
  },
  mutations: {
    SIDEBAR_TOGGLE(state, value){
      state.sidebar_status = typeof value === "boolean" ? value : !state.sidebar_status;
    },
    SIDEBAR_TOGGLE_MINI(state, value){
      state.sidebar_status_mini = typeof value === "boolean" ? value : !state.sidebar_status_mini;
    },
    SIDEBAR_PIN_TOGGLE(state, value){
      const nextValue = typeof value === "boolean" ? value : !state.sidebar_pinned;

      state.sidebar_pinned = nextValue;
      state.sidebar_status = true;
      state.sidebar_status_mini = !nextValue;
    },
  },
  actions: {
  },
  modules: {
    shared,
    auth
  }
})
